import type { RegulationStatus } from '@flipster/apis/v1/regulation/types';

/**
 * Currency/list `*AllowedRegulationStatuses` values (VARA UX Sanitization).
 * @see Notion VARA UX Santization — Logic / currency list
 */
export type CurrencyListAllowedRegulationStatus = 'UNREGULATED' | 'VARA_REGULATED';

/** Whether the current user may perform an action for a currency or network row. */
export function isActionAllowedForRegulation(
  allowedStatuses: string[],
  userRegulationStatus: RegulationStatus,
): boolean {
  if (allowedStatuses.length === 0) return false;
  if (userRegulationStatus === null) {
    return allowedStatuses.includes('UNREGULATED');
  }
  if (userRegulationStatus === 'VARA_REGULATED') {
    return allowedStatuses.includes('VARA_REGULATED');
  }
  return false;
}

/** For static content (e.g. support guide): show row if any regulation segment may use it. */
export function isBlockchainActionInPublicListing(allowedStatuses: string[]): boolean {
  return allowedStatuses.length > 0;
}
